import React from 'react'
import StyledButtonLang from './StyledButtonLang';

interface ButtonLangOptionProps {
  color: string;
  className?: string;
  flagName?: string;
  langName?: string;
  languageCode:string;
  onClickFunc: (languageCode: string) => void;
}

const ButtonLangOption: React.FC<ButtonLangOptionProps> = ({color, className, flagName, langName, languageCode, onClickFunc}) => {

 const handleClick = () => {
      onClickFunc(languageCode); // Chama a função passada com o código do idioma
    };
    return (
        <StyledButtonLang onClick={handleClick} $color={color} className={className}>
            <div className={`flag ${flagName}`}></div>
            <span>{langName}</span>
        </StyledButtonLang>
    )
}

export default ButtonLangOption